import { useApi } from '@/api';
import { KpiCard, Page, PageSkeleton, WalletCard } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricTabs from './HistoricTabs';
import SSRDepositorEventsTable from './SSRDepositorEventsTable';

export default function SSRDepositorEventsPage() {
  const { walletAddress } = useParams();
  const [data, error] = useApi({
    url: `/save/ssr/depositors/${walletAddress}/`,
    queryParams: {
      days_ago: 1
    }
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Page title={<Heading size="1">Depositor</Heading>}>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <WalletCard address={data.wallet_address} />
          <KpiCard
            title="Balance"
            variant="usds"
            field="total_balance"
            data={data}
            options={{
              currency: tokensMapping('USDS'),
              valueOptions: { currencyValueOptions: { iconSize: '4' } }
            }}
          />
        </Flex>
        <HistoricTabs walletAddress={data.wallet_address} />

        <SSRDepositorEventsTable walletAddress={walletAddress} />
      </Page>
    );
  }
  return <PageSkeleton />;
}
